
<template>
  <div class="n_memberDetail">
    <div class="n_user">
      <img :src="info.avatar" alt />
      <div>
        <div class="name_user">{{info.nick_name}}</div>
        <div class="n_time">最近一次购买：{{info.order_at == 0 ? '用户暂无购买记录' : info.order_at_text}}</div>
      </div>
    </div>
    <p class="n_buy">消费记录</p>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <block v-for="item in list" :key="item.id">
        <div class="n_order">
          <div class="flex order_top">
            <div class="flex">
              <img
                class="order-icon"
                v-if="item.order_type!=0&&item.order_type!=5"
                :src="item.order_type==1?imgPath+'yj_present2.png':(item.order_type==2||item.order_type==3||item.order_type==4)?imgPath+'tihuo3.png':''"
              />
              <div
                class="n_orderSn"
              >订单编号：{{(item.order_status == 0 || item.order_status == -1) ? item.order_no : item.chain_order_sn}}</div>
            </div>
            <p class="n_status">{{item.order_status | orderSn}}</p>
          </div>
          <div class="n_goods flex" v-for="titem in item.child_list" :key="titem.id">
            <img :src="titem.goods_image" alt />
            <div class="goods_content">
              <div class="goods_name">{{titem.goods_name}}</div>
              <div>
                <span class="n_sku">规格:{{titem.sku_name}}</span>
                *{{titem.num}}
              </div>
              <div
                class="n_price"
              >¥{{item.order_type == 1 ? titem.market_price_dollar :titem.goods_price_dollar}}</div>
            </div>
          </div>
          <div class="flex just_sttew">
            <p></p>
            <div class="flex">
              <p class="goods_num">共 {{item.total}}件商品，总计：</p>
              <p
                class="goods_price"
              >¥{{item.order_type == 1 ? item.goods_market_all_money : item.pay_money_dollar}}</p>
            </div>
          </div>
        </div>
      </block>
    </van-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      member_id: '',
      finished: false,
      loading: false,
      list: [],
      info: {},
      page: 0,
    }
  },
  created() {},
  mounted() {
    this.getmemberInfo(this.$route.query.id)
    this.prohibitweixinShare()
  },
  filters: {
    orderSn(val) {
      let name
      switch (val) {
        case -1:
          name = '已取消'
          break
        case 0:
          name = '待付款'
          break
        case 1:
          name = '待发货'
          break
        case 2:
          name = '待收货'
          break
        case 3:
          name = '已完成'
          break
        case 4:
          name = '退款中'
          break
        case 5:
          name = '退款审核成功'
          break
      }
      return name
    },
  },
  methods: {
    onLoad() {
      this.page++
      this.getOrderList()
    },
    async getmemberInfo(id) {
      let res = await this.http('ClientMember.memberInfo', {
        member_id: id,
      })
      console.log(res)
      this.info = res.content.info
    },
    async getOrderList() {
      let res = await this.http('ClientOrder.getOrderList', {
        member_id: this.$route.query.id,
        page: this.page,
        limit: 10,
      })
      res.content.list.map((i) => {
        i.total = 0
        i.child_list.map((item) => {
          i.total += item.num
        })
      })
      this.loading = false
      this.list = [...this.list, ...res.content.list]
      this.finished = this.list.length == res.content.count
    },
  },
}
</script>

<style lang="scss" scoped>
.goods_name {
  width: 450px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 28px;
  color: #333333;
}
.n_sku {
  display: inline-block;
  padding: 2px 12px;
  font-size: 24px;
  color: #999999;
  background: #f2f2f2;
  border-radius: 8px;
}
.n_time {
  font-size: 26px;
  color: #969799;
}
.name_user {
  font-size: 28px;
  color: #333333;
}
.goods_price {
  font-size: 30px;
  color: #333333;
}
.goods_num {
  font-size: 26px;
  color: #343434;
}
.n_orderSn {
  font-size: 26px;
  color: #333333;
}
.n_status {
  font-size: 26px;
  color: #f0240e;
}
.n_buy {
  padding: 30px 50px;
  font-size: 32px;
  color: #333333;
}
.just_sttew {
  padding: 0 20px 27px;
  justify-content: space-between;
}
.n_user {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 30px 0 34px 50px;
}
.n_user img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 20px;
}
.n_memberDetail {
  min-height: 98vh;
  background: rgba(249, 249, 249, 1);
  padding: 14px 0;
}
.n_order {
  width: 710px;
  background: #ffffff;
  border-radius: 14px;
  margin: 0 auto 20px;
  box-sizing: border-box;
}
.order_top {
  justify-content: space-between;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  padding: 23px 30px;
}
.n_goods {
  padding: 20px 30px;
}
.goods_content p {
  font-size: 28px;
  color: #333333;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.n_goods img {
  width: 140px;
  height: 140px;
  margin-right: 30px;
}
.order-icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin-right: 9px;
}
</style>